module.exports = __webpack_public_path__ + "static/media/proces.d280ef79.webp";